import actionWrapper from '../../lib/actionWrapper';
import axios from '../../lib/api';
import {LayerDto} from '../type/dtos/Layer';

export default {
    namespace: 'layer',

    state: {
        layers: null,
        groupLayers: null,
    },

    effects: (dispatch: any) => ({
        fetchLayers() {
            return actionWrapper(
                 () => axios.get('layer')
                     .then((res) => dispatch.layer.fetchLayers_reducer(res?.data))
                     .catch(() => dispatch.layer.fetchLayers_reducer(null)),
                dispatch.util.errorHandler,
            );
        },
        fetchGroupLayers(id: string) {
            return actionWrapper(
                 () => axios.get(`layer/group/${id}`)
                     .then((res) => dispatch.layer.fetchGroupLayers_reducer(res?.data))
                     .catch(() => dispatch.layer.fetchGroupLayers_reducer(null)),
                dispatch.util.errorHandler,
            );
        },
    }),

    reducers: {
        fetchLayers_reducer(state: any, payload: LayerDto) {
            return {...state, layers: payload};
        },
        fetchGroupLayers_reducer(state: any, payload: LayerDto) {
            return {...state, groupLayers: payload};
        },
    },
};
